// removed by extract-text-webpack-plugin
module.exports = {"instagramLink":"_2l5CM8PC0Z3vW0lCsibPd3"};


//////////////////
// WEBPACK FOOTER
// ./src/pages/instagramLogin/instagramLogin.scss
// module id = 461
// module chunks = 0